import React from 'react'
import { useSelector } from 'react-redux'

import { CHAT, VIBE } from 'constants/socket'
import {
    gestureEventEmitter,
    gestureKeys,
    vibeEventEmitter,
    vibeKeys,
} from 'helpers/events'
import { triggerClassNotification } from 'helpers/notification'
import { getInfoFromIdentity } from 'helpers/twilio'
import useParticipants from 'hooks/useParticipants/useParticipants'
import { GESTURE } from 'services/webSockets/gestures/constants'
import { _websocketChatMsg } from 'store/selectors/WebSocket'

const useClassNotification = () => {
    const chatMsg = useSelector(_websocketChatMsg)

    const { participants, localParticipant } = useParticipants()

    React.useEffect(() => {
        const handler = message => {
            const { sender, reciever } = message

            if (sender === getInfoFromIdentity(localParticipant.identity).id)
                return

            const senderP = participants?.find(
                p => sender === getInfoFromIdentity(p.identity).id
            )

            if (!senderP) return

            const user = getInfoFromIdentity(senderP.identity).firstName
            const recieverP = participants?.find(
                p => reciever === getInfoFromIdentity(p.identity).id
            )

            if (!recieverP) return

            const user_to = getInfoFromIdentity(recieverP.identity).firstName
            triggerClassNotification(VIBE, { user, user_to })
        }

        vibeEventEmitter.addListener(vibeKeys.VIBE, handler)
        return () => {
            vibeEventEmitter.removeListener(vibeKeys.VIBE, handler)
        }
    }, [participants, localParticipant])

    React.useEffect(() => {
        const handler = message => {
            const { sender: from_user, gestureKey: gesture } = message

            if (from_user === getInfoFromIdentity(localParticipant.identity).id)
                return

            const user = participants?.find(
                p => p && from_user === getInfoFromIdentity(p.identity).id
            )

            if (!user) return

            const firstName = getInfoFromIdentity(user.identity).firstName
            triggerClassNotification(GESTURE, {
                user: firstName,
                gesture,
            })
            return
        }

        gestureEventEmitter.addListener(gestureKeys.GESTURE_MSG, handler)
        return () => {
            gestureEventEmitter.removeListener(gestureKeys.GESTURE_MSG, handler)
        }
    }, [participants, localParticipant])

    React.useEffect(() => {
        if (!chatMsg) return

        if (chatMsg.action === CHAT) {
            if (
                chatMsg.user_id ===
                getInfoFromIdentity(localParticipant.identity).id
            )
                return

            triggerClassNotification(CHAT, {
                user: chatMsg.name.split(' ')[0],
                msg: chatMsg.message,
            })
        }
    }, [chatMsg, localParticipant])

    // user joined and left notifications implemented in room saga handlers

    return null
}

export default useClassNotification
